module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/epic-alt-utils/~/axios/index.js
 ** module id = 199
 ** module chunks = 0
 **/